import { MessageCircle } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Faq } from "../components/Faq";
import { CATEGORY_LABELS, articleBySlug, type ArticleBlock } from "../content/articles";
import { formatDateShort } from "../lib/money";
import { useSupport } from "../lib/support";
import { ArticleCover } from "./ArticlesScreen";

/** Рендер блоков статьи — те форматы, что разрешает ТЗ (экран 12). */
function Block({ block }: { block: ArticleBlock }) {
  switch (block.type) {
    case "p":
      return <p className="article__p">{block.text}</p>;
    case "h":
      return <h2 className="article__h">{block.text}</h2>;
    case "fact":
      return <div className="quote">{block.text}</div>;
    case "list":
      return (
        <ul className="article__list">
          {block.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    case "steps":
      return (
        <ol className="timeline timeline--compact">
          {block.items.map((step, index) => (
            <li key={step.title} className="timeline__step">
              <div className="timeline__rail">
                <span className="timeline__icon timeline__icon--num">{index + 1}</span>
                {index < block.items.length - 1 && <span className="timeline__line" />}
              </div>
              <div className="timeline__body">
                <div className="timeline__title">{step.title}</div>
                <div className="timeline__text">{step.body}</div>
              </div>
            </li>
          ))}
        </ol>
      );
    case "faq":
      return <Faq items={block.items} defaultOpen={0} />;
  }
}

/** Экран 12 ТЗ — статья: обложка сверху, заголовок, дата, тело, CTA. */
export function ArticleScreen() {
  const { slug = "" } = useParams();
  const navigate = useNavigate();
  const support = useSupport();
  const article = articleBySlug(slug);

  if (!article) return <div className="state">Статья не найдена</div>;

  return (
    <article className="screen screen--plain">
      <div className="article__cover">
        <ArticleCover article={article} />
      </div>

      <h1 className="screen__title">{article.title}</h1>
      <p className="screen__subtitle">
        {CATEGORY_LABELS[article.category]} · {formatDateShort(article.date)} · {article.readingMin} мин.
      </p>

      <div className="article__body">
        {article.blocks.map((block, index) => (
          <Block key={index} block={block} />
        ))}
      </div>

      <section className="hero" style={{ marginTop: 28 }}>
        <h2 className="hero__title" style={{ fontSize: 22 }}>Хотите узнать больше о Tirzepatide?</h2>
        <div className="stack" style={{ marginTop: 16 }}>
          <button type="button" className="button button--light" onClick={() => navigate("/")}>
            Перейти к препарату
          </button>
          <button type="button" className="button button--outline" onClick={support.open} disabled={!support.available}>
            <MessageCircle size={17} strokeWidth={1.9} aria-hidden /> Получить консультацию
          </button>
        </div>
      </section>
    </article>
  );
}
